const sameNotices = (previous = [], next = []) => {
  if (!Array.isArray(previous) || !Array.isArray(next)) return false
  if (previous.length !== next.length) return false

  for (let i = 0; i < previous.length; i += 1) {
    const a = previous[i]
    const b = next[i]
    if (
      a?.id !== b?.id ||
      a?.title !== b?.title ||
      a?.notice_date !== b?.notice_date ||
      a?.updatedAt !== b?.updatedAt
    ) {
      return false
    }
  }

  return true
}

const notices = (notices = [], action) => {
  switch (action.type) {
    case 'FETCH_NOTICES':
      return sameNotices(notices, action.payload) ? notices : action.payload
    default:
      return notices
  }
}
export default notices
